const TestimonialSection = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Fatema Dewji',
      position: 'Director of Marketing',
      company: 'MeTL Group',
      content: 'It was an immense pleasure to accept an award for best corporate leader of the year on social media. Thank you for believing in my ability to empower and inspire others through my work. I will continue to work and use my platform to make a difference and make an impact.',
      image: '/assets/testimonials/fatema.jpg'
    },
    {
      id: 2,
      name: 'Bakari Machumu',
      position: 'Managing Director',
      company: 'Mwananchi Communications',
      content: 'This is an inspiration to our online and digital team and the whole company that we continue the efforts in building a strong company in the digital world. Thank you very much and congratulations to the Mwananchi Team.',
      image: '/assets/testimonials/bakari.jpg'
    },
    {
      id: 3,
      name: 'Dr. Anna Makakala',
      position: 'Commissioner General',
      company: 'Tanzania Immigration Department',
      content: 'Our services are now available across the country through the digital systems that Immigration Department has built. They have helped to increase the collection of government revenue. Thanks to the organizers of Tanzania Digital Awards for recognizing our efforts in providing services to the citizens.',
      image: '/assets/testimonials/anna.jpg'
    },
    {
      id: 4,
      name: 'HE Peter Van Acker',
      position: 'Ambassador of Belgium to Tanzania',
      company: '',
      content: 'I am very honored to receive the Digital Award from Serengeti Bytes. I find it to be wonderful initiative by a young company in Tanzania. It is really a very good idea. We diplomats prefer face to face but these days we have to complement our messages with Digital Media. And I think that has been a recognition by Serengeti Bytes that we are doing that well.',
      image: '/assets/testimonials/peter.jpg'
    }
  ];

  return (
    <section 
      className="py-12 md:py-24 bg-gray-50" 
      style={{ 
        backgroundColor: '#f9fafb', 
        padding: '3rem 0' 
      }}
    >
      <div 
        className="container mx-auto px-4" 
        style={{ maxWidth: '1400px' }}
      >
        {/* Section Header */}
        <div 
          className="text-center mb-12 md:mb-16" 
          style={{ marginBottom: '3rem' }}
        >
          <h2 
            className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4" 
            style={{ 
              fontSize: 'clamp(1.5rem, 4vw, 3rem)',
              fontWeight: '700', 
              color: '#111827',
              marginBottom: '0.75rem'
            }}
          >
            What Our Winners Say
          </h2>
          <p 
            className="text-gray-600 text-base md:text-lg max-w-2xl mx-auto" 
            style={{ 
              color: '#6b7280', 
              fontSize: 'clamp(0.875rem, 2vw, 1.125rem)',
              maxWidth: '42rem',
              margin: '0 auto'
            }}
          >
            Hear from the leaders and innovators who are shaping Tanzania's digital future
          </p>
        </div>

        {/* Testimonials Grid - Horizontal scroll on mobile, centered grid on desktop */}
        <div 
          className="testimonials-container"
          style={{ 
            display: 'flex',
            overflowX: 'auto',
            gap: '1rem',
            paddingBottom: '1rem',
            scrollSnapType: 'x mandatory',
            WebkitOverflowScrolling: 'touch'
          }}
        >
          <style>{`
            @media (min-width: 768px) {
              .testimonials-container {
                display: grid !important;
                grid-template-columns: repeat(2, 1fr) !important;
                overflow-x: visible !important;
                max-width: 1200px !important;
                margin: 0 auto !important;
                gap: 2rem !important;
              }
            }
            
            .testimonials-container::-webkit-scrollbar {
              height: 6px;
            }
            
            .testimonials-container::-webkit-scrollbar-track {
              background: #e5e7eb;
              border-radius: 10px;
            }
            
            .testimonials-container::-webkit-scrollbar-thumb {
              background: #ffba17;
              border-radius: 10px;
            }
            
            .testimonials-container::-webkit-scrollbar-thumb:hover {
              background: #ea580c;
            }
          `}</style>
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id} 
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 relative testimonial-card"
              style={{
                backgroundColor: 'white',
                borderRadius: '0.75rem',
                padding: '1.25rem',
                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                position: 'relative',
                transition: 'all 0.3s ease',
                display: 'flex',
                flexDirection: 'column',
                minHeight: '280px',
                minWidth: '280px',
                maxWidth: '320px',
                scrollSnapAlign: 'start',
                flexShrink: 0
              }}
            >
              <style>{`
                @media (min-width: 768px) {
                  .testimonial-card {
                    padding: 2.5rem !important;
                    min-height: 320px !important;
                    min-width: auto !important;
                    max-width: none !important;
                  }
                }
              `}</style>
              {/* Quote Icon */}
              <div 
                className="absolute quote-icon"
                style={{
                  position: 'absolute',
                  top: '1rem',
                  left: '1rem',
                  color: '#ffba17',
                  opacity: '0.15',
                  fontSize: '2.5rem',
                  lineHeight: '1'
                }}
              >
                <style>{`
                  @media (min-width: 768px) {
                    .quote-icon {
                      top: 1.5rem !important;
                      left: 1.5rem !important;
                      font-size: 4rem !important;
                    }
                  }
                `}</style>
                <i className="fa-solid fa-quote-left"></i>
              </div>

              {/* Content */}
              <div 
                className="relative z-10 flex-grow testimonial-content"
                style={{
                  marginBottom: '1rem',
                  position: 'relative',
                  zIndex: 10,
                  flexGrow: 1
                }}
              >
                <style>{`
                  @media (min-width: 768px) {
                    .testimonial-content {
                      margin-bottom: 2rem !important;
                    }
                  }
                `}</style>
                <p 
                  className="text-gray-700 testimonial-text"
                  style={{
                    color: '#374151',
                    fontSize: '0.875rem',
                    lineHeight: '1.6',
                    textAlign: 'justify'
                  }}
                >
                  <style>{`
                    @media (min-width: 768px) {
                      .testimonial-text {
                        font-size: 1rem !important;
                        line-height: 1.8 !important;
                      }
                    }
                  `}</style>
                  "{testimonial.content}"
                </p>
              </div>

              {/* Author Info */}
              <div 
                className="flex items-center author-info"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  paddingTop: '1rem',
                  borderTop: '1px solid #e5e7eb'
                }}
              >
                <style>{`
                  @media (min-width: 768px) {
                    .author-info {
                      padding-top: 1.5rem !important;
                    }
                  }
                `}</style>
                {/* Avatar */}
                <div 
                  className="rounded-full overflow-hidden flex-shrink-0 bg-gradient-to-br from-blue-900 to-orange-500 author-avatar"
                  style={{
                    width: '3rem',
                    height: '3rem',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    marginRight: '0.75rem',
                    flexShrink: 0,
                    background: 'linear-gradient(135deg, #0f1b3c 0%, #ffba17 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <style>{`
                    @media (min-width: 768px) {
                      .author-avatar {
                        width: 4rem !important;
                        height: 4rem !important;
                        margin-right: 1rem !important;
                      }
                    }
                  `}</style>
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.style.display = 'none';
                      const parent = target.parentElement;
                      if (parent) {
                        parent.innerHTML = `<span style="color: white; font-size: 1.5rem; font-weight: 700;">${testimonial.name.charAt(0)}</span>`;
                      }
                    }}
                  />
                </div>

                {/* Name and Position */}
                <div style={{ flex: 1 }}>
                  <h5 
                    className="font-bold text-gray-900 author-name"
                    style={{
                      fontSize: '0.875rem',
                      fontWeight: '700',
                      color: '#111827',
                      marginBottom: '0.125rem',
                      lineHeight: '1.3'
                    }}
                  >
                    <style>{`
                      @media (min-width: 768px) {
                        .author-name {
                          font-size: 1.125rem !important;
                          margin-bottom: 0.25rem !important;
                        }
                      }
                    `}</style>
                    {testimonial.name}
                  </h5>
                  <p 
                    className="text-orange-500 font-semibold author-position"
                    style={{
                      color: '#ffba17',
                      fontWeight: '600',
                      fontSize: '0.75rem',
                      marginBottom: '0.125rem',
                      lineHeight: '1.3'
                    }}
                  >
                    <style>{`
                      @media (min-width: 768px) {
                        .author-position {
                          font-size: 0.875rem !important;
                          margin-bottom: 0.25rem !important;
                        }
                      }
                    `}</style>
                    {testimonial.position}
                  </p>
                  {testimonial.company && (
                    <p 
                      className="text-gray-600 author-company"
                      style={{
                        color: '#6b7280',
                        fontSize: '0.75rem',
                        lineHeight: '1.3'
                      }}
                    >
                      <style>{`
                        @media (min-width: 768px) {
                          .author-company {
                            font-size: 0.875rem !important;
                          }
                        }
                      `}</style>
                      {testimonial.company}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
